export const walletHasCreditCard = (cards) =>
  cards.some(
    (el) =>
      el.creditSummary[0].cardType === 'B' ||
      el.creditSummary[0].cardType === 'Y' ||
      el.creditSummary[0].cardType === 'U' ||
      el.creditSummary[0].cardType === 'F',
  );
